export enum TipsTab {
  SUMMARY = 'Summary',
  DETAILS = 'Details',
}

export enum SummaryType {
  EMPLOYEE = 'employee',
  PAYMENT_TYPE = 'payment_type',
}
